import React, { useEffect, useContext, useState }  from 'react'
import { View, StyleSheet, ScrollView, Platform } from 'react-native'
import { Button, Text, Spinner, Layout, RangeDatepicker, useTheme } from '@ui-kitten/components'
import { LineChart } from "react-native-chart-kit"
import { Text as TextSVG } from "react-native-svg"
import { UserContext } from '../../global/UserProvider'
import { useTranslation } from 'react-i18next'
import { constantsAtom, currencyFormatterAtom, localeDateServiceAtom, storesDictAtom } from '../../global/AtomsProvider'
import { useAtomValue } from 'jotai'
import StoreChooserHorizontal from '../../components/StoreChooserHorizontal'

const chartData = {
  labels: ["Янв", "Фев", "Мар", "Апр", "Май", "Июнь"],
  data: [24000, 19000, 34000, 45000, 35000, 54000]
}

export default function SalesStats({ navigation, route }) {
  const theme = useTheme()
  const { t } = useTranslation()
  const [context, setContext] = useContext(UserContext)
  const currencyFormatter = useAtomValue(currencyFormatterAtom)
  const constants = useAtomValue(constantsAtom)
  const db = context.db
  const localeDateService = useAtomValue(localeDateServiceAtom)
  const [store, setStore] = useState(context.user.store?.id)
  const [range, setRange] = useState({})
  const [revenueChartData, setRevenueChartData] = useState(chartData)
  const _rangePicker = React.createRef()

  useEffect(() => {
    const d = new Date()
    var day = d.getDay(),
    diff = d.getDate() - day + (day == 0 ? -6:1) // adjust when day is sunday
    const monday = new Date(d.setDate(diff))
    const newRange = {
      startDate: monday,
      endDate: new Date(),
    }
    setRange(newRange)
    getDataFromFB(newRange)
  }, [store])

  const getDataFromFB = async (newRange) => {
    
  }

  const TimeChart = ({timeData, legend, dotManipulation, ySuffix}) => {
    if (Platform.OS === 'android') {
      return null
    }
    return (
      <LineChart 
        data={{
          labels: revenueChartData.labels,
          datasets: [
            {
              data: timeData
            },
          ],
          legend: [legend]
        }}
        width={revenueChartData.labels.length * 100} // from react-native
        height={220}
        // yAxisLabel="  . "
        yAxisSuffix={ySuffix}
        yAxisInterval={1} // optional, defaults to 1
        yLabelsOffset={20}
        chartConfig={{
          backgroundColor: "#e26a00",
          backgroundGradientFrom: "#fb8c00",
          backgroundGradientTo: "#ffa726",
          decimalPlaces: 0, // optional, defaults to 2dp
          color: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
          labelColor: (opacity = 1) => `rgba(255, 255, 255, ${opacity})`,
          style: {
            borderRadius: 16
          },
          propsForDots: {
            r: "6",
            strokeWidth: "2",
            stroke: "#ffa726"
          },
        }}
        renderDotContent={
          ({x, y, index, indexData}) => 
            <TextSVG 
              fill={theme['background-basic-color-1']}
              key={x+y+''}
              stroke="none"
              fontSize="10"
              fontWeight="regular"
              x={x}
              y={y-8}
              textAnchor="middle"
            >
                {dotManipulation(indexData)}
            </TextSVG>
        }
        bezier
        style={{
          borderRadius: 16,
        }}
      /> 
    )
  }
  
  return (    
    <ScrollView style={{padding: 20}}>
      <StoreChooserHorizontal store={store} onChange={(newStore) => {
        setStore(newStore)
      }} />
      <View style={styles.dateFilter}>
        <Text category='label' style={styles.label}>
          Фильтр по дате
        </Text>
        <RangeDatepicker
          placement='top'
          range={range}
          ref={_rangePicker}
          min={new Date('2020-12-01')}
          max={new Date('2029-12-31')}
          dateService={localeDateService}
          onSelect={(newRange) => {
            if (newRange.endDate) {
              setRange(newRange)
              getDataFromFB(newRange)
            } else if (newRange.startDate && range.startDate === newRange.startDate) {
              let endDate = new Date(newRange.startDate)
              endDate.setHours('23', '59', '59', '99')
              setRange({startDate: newRange.startDate, endDate})
              getDataFromFB({startDate: newRange.startDate, endDate})
            } else {
              setRange(newRange)
            }
          }}
        />
      </View>

      {/* { data ? ( */}
        <>
          <Text category='h2' style={styles.header}>
            {'Отчет по проектам'}
          </Text>
          <Text category='label' style={styles.label}>
            Общее
          </Text>
          <Layout style={styles.tableView}>
            <Text category='label' style={styles.label}>
              За последние 6 месяцев
            </Text>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Количество</Text>
              <Text style={styles.rowItemAmount}>{12}</Text>
            </View>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Утвержденный план по доходу</Text>
              <Text style={styles.rowItemAmount}>{'150 000 000'}</Text>
            </View>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Плановый доход</Text>
              <Text style={styles.rowItemAmount}>{'160 000 000'}</Text>
            </View>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Фактический доход</Text>
              <Text style={styles.rowItemAmount}>{'140 000 000'}</Text>
            </View>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Фактический vs Утвержденный доход</Text>
              <Text style={styles.rowItemAmount}>{'-10 000 000'}</Text>
            </View>
          </Layout>
          <ScrollView style ={{marginBottom: 20}} horizontal={true}>
            <View>
              <TimeChart timeData={revenueChartData.data.map((value, index) => {return value/1000})} legend='Общие доходы' dotManipulation={(indexData) => {return (indexData*1000)?.toFixed()}} ySuffix={'k '} />
            </View>
          </ScrollView>
          <Text category='label' style={styles.label}>
            По месяцам
          </Text>
          <Layout style={styles.tableView}>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Таблица...</Text>
              {/* <Text style={styles.rowItemAmount}>{'140 000 000' + currency?.text}</Text> */}
            </View>
          </Layout>
          <Text category='label' style={styles.label}>
            Проекты
          </Text>
          <Layout style={styles.tableView}>
            <View style={styles.rowItem}>
              <Text style={styles.rowItemName}>Таблица...</Text>
              {/* <Text style={styles.rowItemAmount}>{'140 000 000' + currency?.text}</Text> */}
            </View>
          </Layout>
        </>
      {/* ) : (
        <View style={styles.spinner}>
          <Spinner size="large" />
        </View>
      )} */}

      
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  header: {
    marginVertical: 10,
  },
  tableView: {
    padding: 10,
    marginBottom: 10,
    borderRadius: 10,
  },
  rowItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginVertical: 2,
  }, 
  rowItemName: {
    flex: 9
  }, 
  rowItemAmount: {
    flex: 4,
    textAlign: 'right',
  },
  label: {
    marginTop: 5,
    marginBottom: 5,
  }
})